import React from 'react';
import './EntryChoice.css';

const EntryChoice = ({ onSelectAsimo }) => {
  const openNexus = () => {
    window.location.replace('https://nexusgecs.in');
  };

  return (
    <main className="entry-choice" aria-labelledby="entry-choice-title">
      <div className="entry-choice__backdrop" aria-hidden="true">
        <span className="entry-choice__orb entry-choice__orb--one" />
        <span className="entry-choice__orb entry-choice__orb--two" />
        <span className="entry-choice__grid" />
      </div>

      <section className="entry-choice__panel">
        <p className="entry-choice__eyebrow">Choose your portal</p>
        <h1 id="entry-choice-title">Select the website you want to open</h1>
        <p className="entry-choice__subtitle">
          Nexus'26 is the techfest website. ASIMO is the technical club website and continues into this project.
        </p>

        <div className="entry-choice__options">
          <button
            type="button"
            className="entry-choice__option entry-choice__option--nexus"
            onClick={openNexus}
          >
            <span className="entry-choice__option-tag">Option 1</span>
            <span className="entry-choice__option-title">Nexus'26</span>
            <span className="entry-choice__option-copy">Techfest website</span>
          </button>

          <button
            type="button"
            className="entry-choice__option entry-choice__option--asimo"
            onClick={onSelectAsimo}
          >
            <span className="entry-choice__option-tag">Option 2</span>
            <span className="entry-choice__option-title">ASIMO</span>
            <span className="entry-choice__option-copy">Club website</span>
          </button>
        </div>
      </section>
    </main>
  );
};

export default EntryChoice;